export interface EnvironmentConfig {
  apiBaseUrl: string;
  apiSecretKey: string;
  environment: "development" | "staging" | "production";
  enableLogging: boolean;
  enableMockData: boolean;
  /** Base encryption toggle from REACT_APP_ENABLE_ENCRYPTION. Runtime override: ?bypassEncryption=true disables encryption */
  enableEncryption: boolean;
  features: {
    analytics: boolean;
    notifications: boolean;
    multiLanguage: boolean;
  };
}

const getEnvironment = (): EnvironmentConfig["environment"] => {
  const nodeEnv = process.env.NODE_ENV;

  // Use NODE_ENV to determine environment
  if (nodeEnv === "production") return "production";
  if (nodeEnv === "test") return "staging";
  return "development";
};

const config: EnvironmentConfig = {
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL || "http://localhost:3001/api",
  apiSecretKey:
    process.env.REACT_APP_API_SECRET_KEY ||
    (() => {
      throw new Error(
        "REACT_APP_API_SECRET_KEY environment variable is required"
      );
    })(),
  environment: getEnvironment(),
  enableLogging: process.env.NODE_ENV !== "production",
  enableMockData: process.env.REACT_APP_USE_MOCK_DATA === "true",
  enableEncryption: process.env.REACT_APP_ENABLE_ENCRYPTION === "true",
  features: {
    analytics: process.env.REACT_APP_ENABLE_ANALYTICS === "true",
    notifications: process.env.REACT_APP_ENABLE_NOTIFICATIONS !== "false",
    multiLanguage: process.env.REACT_APP_ENABLE_MULTI_LANGUAGE !== "false",
  },
};

// Log the API base URL in development for debugging
if (config.enableLogging) {
  console.log("[Environment Config] API Base URL:", config.apiBaseUrl);
  console.log(
    "[Environment Config] REACT_APP_API_BASE_URL from env:",
    process.env.REACT_APP_API_BASE_URL
  );
}

export default config;

// Utility functions for environment checks
export const isDevelopment = () => config.environment === "development";
export const isProduction = () => config.environment === "production";
export const isStaging = () => config.environment === "staging";

// Feature flags
export const isFeatureEnabled = (
  feature: keyof EnvironmentConfig["features"]
): boolean => {
  return config.features[feature];
};

// Logging utility
export const log = (...args: any[]) => {
  if (config.enableLogging) {
    console.log("[SummarizeX Dashboard]", ...args);
  }
};

export const logError = (...args: any[]) => {
  if (config.enableLogging) {
    console.error("[SummarizeX Dashboard Error]", ...args);
  }
};
